import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameModel } from "../GameModel";

export class Timer extends Phaser.Group {

    public static currentInstance: Timer;
    
    private timeLabel: Phaser.BitmapText;
    private paused: boolean;
    
    constructor(game: Phaser.Game) {
        
        super(game, null, "timer");
        
        Timer.currentInstance = this;
        
        this.paused = true;
        
        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = 622;
        
        this.scale.x = GameVars.scaleX;
        
        this.timeLabel = new Phaser.BitmapText( this.game, 0, -2, "times-roman", GameVars.getInstance().formatTime(GameVars.getInstance().time), 30);
        this.timeLabel.tint = 0xffe25b;
        this.timeLabel.x -= this.timeLabel.width / 2;
        this.timeLabel.y -= this.timeLabel.height / 2;
        this.add(this.timeLabel);
            
        const clockReflex = new Phaser.Image(this.game, 0, -20, "texture_atlas_1", "brillo_reloj.png");
        clockReflex.anchor.x = .5;
        this.add(clockReflex);
    }
    
    public start(): void {
        
        this.paused = false;
        
        this.game.time.events.loop(1000, this.updateTimeLabel, this);
    }
    
    public pause(): void {
        
        this.paused = true;
    }
    
    public resume(): void {
        
        this.paused = false;
    }
        
    private updateTimeLabel(): void {
        
        if (this.paused) {
            return;
        }
        
        if (GameVars.getInstance().time !== 0) {
                
            GameVars.getInstance().time--;
            this.timeLabel.text = GameVars.getInstance().formatTime(GameVars.getInstance().time);
            
        } else {
                
                GameModel.currentInstance.onGameLost();
        }
    }
}
